import { Icon, PopoverListButtonItem } from '@aibees/shared/components';
import { SavedSearchTableActionType as Action } from './types';

export const SAVED_SEARCH_ACTION_MENU_ITEMS: PopoverListButtonItem[] = [
  {
    label: 'View In Search',
    key: Action.view,
    icon: <Icon name="eye-outlined" size={18} color="primary.500" />,
  },
  {
    label: 'Edit',
    key: Action.edit,
    icon: <Icon name="edit-outline" size={18} color="primary.500" />,
  },
  {
    label: 'Delete',
    key: Action.delete,
    icon: <Icon name="delete-outline" size={18} color="primary.500" />,
  },
];
